import { helper } from '@ember/component/helper';

export function sub([a, b]: [number, number]): number {
  return a - b;
}

export default helper(sub);
